import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { get, post } from '@api/httpClient';
import { APIError } from '@api/types';
import queryClient from '@api/queryClient';
import { type FlowgateDiscussionEntry } from '@api/flowgate/types';

const DISCUSSION = (resultId: string) => ['flowgate', 'discussion', resultId];

export const useFlowgateDiscussion = (resultId?: string) =>
  useQuery<FlowgateDiscussionEntry[]>({
    queryKey: DISCUSSION(resultId || ''),
    enabled: !!resultId,
    refetchInterval: 8000,
    queryFn: async () => {
      if (!resultId) return [];
      const resp = await get<FlowgateDiscussionEntry[]>(
        `flowgate/results/${resultId}/discussion/`,
      );
      return resp.data;
    },
  });

export const usePostFlowgateDiscussion = () =>
  useMutation<
    AxiosResponse<FlowgateDiscussionEntry>,
    APIError,
    { resultId: string; body: string }
  >({
    mutationFn: ({ resultId, body }) =>
      post<FlowgateDiscussionEntry>(
        `flowgate/results/${resultId}/discussion/`,
        { body },
      ),
    onSuccess: (_resp, variables) => {
      queryClient.invalidateQueries({
        queryKey: DISCUSSION(variables.resultId),
      });
    },
  });
